var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 4.99999H7.34375C6.05141 4.99999 5 6.0514 5 7.34374V10.1875C5 11.4798 6.05141 12.5312 7.34375 12.5312H10.1875C11.4798 12.5312 12.5312 11.4798 12.5312 10.1875V7.34374C12.5312 6.0514 11.4798 4.99999 10.1875 4.99999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 13.4687H15.8125C14.5202 13.4687 13.4688 14.5201 13.4688 15.8125V18.6562C13.4688 19.9486 14.5202 21 15.8125 21H18.6562C19.9486 21 21 19.9486 21 18.6562V15.8125C21 14.5201 19.9486 13.4687 18.6562 13.4687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 4.99999H15.8125C14.5202 4.99999 13.4688 6.0514 13.4688 7.34374V10.1875C13.4688 11.9968 11.9968 13.4687 10.1875 13.4687H7.34375C6.05141 13.4687 5 14.5201 5 15.8125V18.6562C5 19.9486 6.05141 21 7.34375 21H10.1875C11.4798 21 12.5312 19.9486 12.5312 18.6562V15.8125C12.5312 14.0032 14.0032 12.5312 15.8125 12.5312H18.6562C19.9486 12.5312 21 11.4798 21 10.1875V7.34374C21 6.0514 19.9486 4.99999 18.6562 4.99999Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 4.99999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.9b12b2ced479fc64967aabcef0c23030.svg";
export { ForwardRef as ReactComponent };